import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CiSearch } from "react-icons/ci";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  useGetCategoryQuery,
  useGetPrinterQuery,
  useGetProductWithStoreQuery,
  useDeleteProductMutation,
  useGetBrandQuery,
  useGetProducHistroyRecordQuery,
  useGetProducStoreHistroyRecordQuery,
  useGetTagQuery,
  useGetStoreQuery,
  useGetMainItemQuery,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IMainItem,
  IVariantView,
  IStore,
  IBrand,
  ITag,
  IPrinter,
  IProductPriceSplineChart,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopupTenant from "../Edit/index";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import NewPopUpProduct from "../../Product/Edit/index";
import { useNotifier } from "../../../Core/Notifier";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import StoreIcon from "@mui/icons-material/Store";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import ProductPriceChart from "./ProductPriceChart";
import { IoIosArrowRoundForward } from "react-icons/io";
import dayjs, { Dayjs } from "dayjs";
import StorepriceOnly from "../../Product/Edit/storepriceOnly";
import { FcPicture } from "react-icons/fc";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const variantPropName = (unit: string) => {
  switch (unit) {
    case "variantName":
      return "Name";
    case "variantDisplayName":
      return "Display Name";
    case "categoryId":
      return "Category";
    case "cost":
      return "Cost";
    case "regularPrice":
      return "Regular Price";
    case "salePrice":
      return "Sale Price";
    case "variantShortDescription":
      return "Short Description";
    case "variantLongDescription":
      return "Long Description";
    case "variantUnit":
      return "Variant Unit";
    case "mainItemId":
      return "Product";
    case "packCount":
      return "Pack Count";
    case "categoryId":
      return "Category";
    case "size":
      return "Size";
    case "bgColor":
      return "Button Color";
    case "orderNumber":
      return "Order Number";
    case "isPosDisplay":
      return "Display";
    case "isOnSale":
      return "Sale";
    case "variantBrandId":
      return "Brand ";
    case "variantTagId":
      return "Tag";
    case "quantityKgOrLi":
      return "quantityKgOrLi";
    case "quantitySmallUnit":
      return "quantitySmallUnit";
    case "variantPrinterIds":
      return "Printers";
    case "isActive":
      return "Active";
    case "variantImg":
      return "Image";
    default:
      return "";
  }
};
const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { showErrorMessage, showMessage } = useNotifier();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<IVariantView | null>(
    null
  );
  const [openDialogProduct, setOpenDialogProduct] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IVariantView | null>(
    null
  );
  const [selectCustomer, setSelectCustomer] = useState<IMainItem | null>(null);
  const [selectedProduct2, setSelectedProduct2] = useState<IVariantView | null>(
    null
  );
  const [openDialogProduct2, setOpenDialogProduct2] = useState(false);
  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  const { data, isLoading, isError } = useGetProductWithStoreQuery({
    searchText: "",
    id: String(ProductId),
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: null,
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
  });

  const { data: productBrandData, isLoading: brandIsLoading } =
    useGetBrandQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });
  const { data: productTagData, isLoading: ProductTagLoading } = useGetTagQuery(
    {
      searchText: "",
      isActive: "1",
      id: "",
    }
  );

  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const {
    data: productStoreHistoryRecordData,
    isLoading: storeRecordIsLoading,
  } = useGetProducStoreHistroyRecordQuery({
    productDetailsId: String(ProductId),
  });

  const {
    data: productHistoryRecordData,
    isLoading: productRecordIsLoading,
    isError: productIsError,
  } = useGetProducHistroyRecordQuery({
    productDetailsId: String(ProductId),
  });

  const { data: maintItemData, isLoading: mainItemIsLoading } =
    useGetMainItemQuery({
      searchText: "",
      id: "",
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
    });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IVariantView;
    }
    return null;
  }, [data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as ITag[];
  }, [productTagData?.data]);

  const printerList = useMemo(() => {
    return printerData?.data as IPrinter[];
  }, [printerData?.data]);

  const productHistoryRecordList = useMemo(() => {
    return productStoreHistoryRecordData?.data as IProductPriceSplineChart[];
  }, [productStoreHistoryRecordData?.data]);

  const mainItemList = useMemo(() => {
    return maintItemData?.data as IMainItem[];
  }, [maintItemData?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, toProperCase(category.categoryName));
    });
    return map;
  }, [categoryList]);

  const mainItenMap = useMemo(() => {
    const map = new Map();
    mainItemList?.forEach((category) => {
      map.set(category.id, toProperCase(category.mainItemName));
    });
    return map;
  }, [mainItemList]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, toProperCase(brand.brandName));
    });
    return map;
  }, [productBrandList]);

  const tagMap = useMemo(() => {
    const map = new Map();
    productTagList?.forEach((brand) => {
      map.set(brand.id, brand.tagName);
    });
    return map;
  }, [productTagList]);

  const printerMap = useMemo(() => {
    const map = new Map();
    printerList?.forEach((brand) => {
      map.set(brand.id, toProperCase(brand.printerName));
    });
    return map;
  }, [printerList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, toProperCase(category.storeName));
    });
    return map;
  }, [getAllStoreList]);

  const handleOpenDialog = (product: IVariantView) => {
    setSelectedProduct(product);
    setOpenDialogProduct(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialogProduct(false);
  };

  const handleOpenDialog2 = (product: IVariantView) => {
    setSelectedProduct2(product);
    setOpenDialogProduct2(true);
  };

  const handleCloseDialog2 = () => {
    setSelectedProduct2(null);
    setOpenDialogProduct2(false);
  };

  const handleOpenDeletePopup = (product: IVariantView) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleAddProductClick = () => {
    navigate(`/product/create/${product?.id}`);
  };

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProduct(false);
        navigate(`/main/item/view/${product?.mainItemId}`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const StatusCard = ({ label, value }: { label: string; value: boolean }) => (
    <Card
      sx={{
        padding: 2,
        height: "100%",
        border: `1px solid ${value ? "#4caf50" : "#f44336"}`,
        backgroundColor: value ? "#e8f5e9" : "#ffebee",
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        wrap="nowrap"
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {label}
        </Typography>
        {value ? (
          <CheckCircleOutlinedIcon sx={{ color: "#4caf50", fontSize: 36 }} />
        ) : (
          <HighlightOffOutlinedIcon sx={{ color: "#f44336", fontSize: 36 }} />
        )}
      </Grid>
    </Card>
  );

  const CompactStatusCard = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? CheckCircleIcon : CancelIcon;

    return (
      <Card
        sx={{
          padding: 2,
          borderRadius: 3,
          height: "100%",
          display: "flex",
          alignItems: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  if (isLoading || categoryLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

  const coursings: IVariantView[] = Array.isArray(
    productHistoryRecordData?.data
  )
    ? (productHistoryRecordData?.data as IVariantView[])
    : [];

  return (
    <Grid container spacing={3}>
      <Grid item lg={4} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Box className={classes.productBox}>
                          {/* <img
                            src={product?.variantImg}
                            alt="Product"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "cover",
                            }}
                          /> */}
                          {product?.variantImg ? (
                            <img
                              src={product?.variantImg}
                              alt="img"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <FcPicture
                              // className={classes.SelectImageTable}
                              style={{ fontSize: 60 }}
                            />
                          )}
                        </Box>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="h4" textAlign={"center"}>
                          {toProperCase(product?.variantName)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            {(product?.cost || product?.regularPrice || product?.salePrice) && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{
                    p: 2,
                    boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
                  }}
                >
                  <Grid container justifyContent={"space-between"} spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        color="primary"
                        gutterBottom
                      >
                        Pricing Summary
                      </Typography>
                      <Stack spacing={1} px={2} py={1}>
                        {product?.cost && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <MonetizationOnIcon
                              color="success"
                              sx={{ mr: 1 }}
                            />
                            <Typography variant="body2">
                              Cost: ${product.cost}
                            </Typography>
                          </Box>
                        )}
                        {product?.regularPrice && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <PriceChangeIcon color="primary" sx={{ mr: 1 }} />
                            <Typography variant="body2">
                              Regular: ${product.regularPrice}
                            </Typography>
                          </Box>
                        )}
                        {product?.salePrice && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <LocalOfferIcon color="error" sx={{ mr: 1 }} />
                            <Typography variant="body2">
                              Sale: ${product.salePrice}
                            </Typography>
                          </Box>
                        )}
                      </Stack>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            )}
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={8} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <CompactStatusCard
                    label="Active"
                    status={!!product?.isActive}
                  />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <CompactStatusCard
                    label="Can Sell"
                    status={!!product?.isOnSale}
                  />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <CompactStatusCard
                    label="Display"
                    status={!!product?.isPosDisplay}
                  />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <CompactStatusCard
                    label="Looping"
                    status={!!product?.isLooping}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card
                className={classes.stepperCard}
                sx={{
                  p: 3,
                  boxShadow: "0px 6px 18px rgba(0,0,0,0.06)",
                }}
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  color="primary"
                  gutterBottom
                  sx={{ mb: 2 }}
                >
                  Store-wise Pricing Summary
                </Typography>

                {product?.storeDetails && product.storeDetails.length > 0 ? (
                  <Grid container spacing={3}>
                    {product.storeDetails.map((store, index) => (
                      <Grid item key={index} lg={4} md={6} sm={12} xs={12}>
                        <Paper
                          elevation={1}
                          sx={{
                            p: 2.5,
                            borderRadius: 3,
                            height: "100%",
                            background:
                              "linear-gradient(to bottom, #f9f9f9, #fff)",
                            border: "1px solid #e0e0e0",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenDialog2(product)}
                        >
                          <Stack spacing={1.5}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <StoreIcon color="primary" />
                              <Typography variant="subtitle1" fontWeight="bold">
                                {getStoreMap.get(store.storeId) ||
                                  "Unnamed Store"}
                              </Typography>
                            </Box>

                            <Box display="flex" alignItems="center" gap={1}>
                              <MonetizationOnIcon color="success" />
                              <Typography variant="body1" fontWeight="bold">
                                {store.price !== null
                                  ? `$${store.price}`
                                  : "N/A"}
                              </Typography>
                            </Box>

                            {store.referenceNo && (
                              <Box display="flex" alignItems="center" gap={1}>
                                <InfoOutlinedIcon color="info" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Ref No: {store.referenceNo}
                                </Typography>
                              </Box>
                            )}
                          </Stack>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No pricing details available for any store.
                  </Typography>
                )}
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={1}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color="primary"
                          gutterBottom
                          // textTransform={"uppercase"}
                        >
                          Variant Detail
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {product && (
                          <Grid
                            container
                            spacing={1}
                            justifyContent="flex-end"
                            sx={{ display: "flex" }}
                          >
                            {/* <Grid item>
                              <Button
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/variant/view/${product?.id || ""}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid> */}

                            <Grid item>
                              <Button
                                // variant="contained"
                                className={classes.editButtonList}
                                onClick={() => handleOpenDialog(product)}
                              >
                                <EditSharpIcon
                                  className={classes.editListIcon}
                                />
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                // variant="contained"
                                className={classes.deleteButtonList}
                                onClick={() => handleOpenDeletePopup(product)}
                              >
                                <DeleteOutlineSharpIcon
                                  className={classes.deleteListIcon}
                                />
                              </Button>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      <Grid item xs={12}>
                        <Stack spacing={2}>
                          <Typography variant="subtitle1">
                            <strong>Name :</strong>{" "}
                            {toProperCase(product?.variantName)}
                          </Typography>

                          {product?.variantDisplayName && (
                            <Typography variant="subtitle1">
                              <strong>Display Name :</strong>{" "}
                              {toProperCase(product.variantDisplayName)}
                            </Typography>
                          )}

                          {product?.mainItemId && (
                            <Typography
                              variant="subtitle1"
                              sx={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/main/item/view/${product.mainItemId}`
                                )
                              }
                            >
                              <strong>Product :</strong>{" "}
                              {mainItenMap.get(product.mainItemId) || ""}
                            </Typography>
                          )}

                          {product?.categoryId && (
                            <Typography variant="subtitle1">
                              <strong>Category :</strong>{" "}
                              {categoryMap.get(product.categoryId) || ""}
                            </Typography>
                          )}

                          {product?.variantBrandId && (
                            <Typography variant="subtitle1">
                              <strong>Brand :</strong>{" "}
                              {productBrandMap.get(product.variantBrandId) ||
                                ""}
                            </Typography>
                          )}

                          {product?.variantTagId &&
                            product?.variantTagId?.length > 0 && (
                              <Typography variant="subtitle1">
                                <strong>Tags :</strong>{" "}
                                {product?.variantTagId
                                  .map((id) => tagMap.get(id) || "")
                                  .join(", ")}
                              </Typography>
                            )}

                          {product?.variantPrinterIds &&
                            product?.variantPrinterIds?.length > 0 && (
                              <Typography variant="subtitle1">
                                <strong>Printers :</strong>{" "}
                                {product?.variantPrinterIds
                                  .map((id) => printerMap.get(id) || "")
                                  .join(", ")}
                              </Typography>
                            )}

                          {/* Units */}
                          {product?.variantUnit && (
                            <Typography variant="subtitle1">
                              <strong>Conversion Unit :</strong>{" "}
                              {convertUnit(product.variantUnit)}
                            </Typography>
                          )}

                          {product?.packCount && (
                            <Typography variant="subtitle1">
                              <strong>Pack Count :</strong> {product.packCount}
                            </Typography>
                          )}

                          {product?.size && (
                            <Typography variant="subtitle1">
                              <strong>Size :</strong> {product.size}
                            </Typography>
                          )}

                          {product?.orderNumber && (
                            <Typography variant="subtitle1">
                              <strong>Order Number :</strong>{" "}
                              {product.orderNumber}
                            </Typography>
                          )}

                          {product?.bgColor && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography variant="subtitle1">
                                <strong>Button Color :</strong>
                              </Typography>
                              <Chip
                                label="Button Color"
                                sx={{
                                  backgroundColor: product.bgColor,
                                  color: product.bgColor,
                                }}
                              />
                            </Box>
                          )}

                          {product?.isLooping == true && (
                            <Box>
                              <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: "bold" }}
                              >
                                <strong> Looping :</strong>{" "}
                                {product?.loopingDetails?.shortTableName}
                              </Typography>
                              <Stack spacing={1} pl={2}>
                                {product?.loopingDetails?.tableColumns &&
                                  product.loopingDetails.tableColumns.filter(
                                    (column) => column.value !== null
                                  ).length > 0 && (
                                    <>
                                      {product.loopingDetails.tableColumns
                                        .filter(
                                          (column) => column.value !== null
                                        )
                                        .map((column, index) => (
                                          <Typography
                                            key={index}
                                            variant="subtitle2"
                                            sx={{ fontSize: "13px" }}
                                          >
                                            <span
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              {column.name} :
                                            </span>{" "}
                                            {column.type === "boolean"
                                              ? column.value
                                                ? "True"
                                                : "False"
                                              : column.value}
                                          </Typography>
                                        ))}
                                    </>
                                  )}
                              </Stack>
                            </Box>
                          )}

                          {product?.variantShortDescription && (
                            <Typography variant="subtitle1">
                              <strong>Short Description :</strong>{" "}
                              {product.variantShortDescription}
                            </Typography>
                          )}

                          {product?.variantLongDescription && (
                            <Typography variant="subtitle1">
                              <strong>Long Description :</strong>{" "}
                              {product.variantLongDescription}
                            </Typography>
                          )}

                          {/* Order & Status */}

                          {/* Flags */}
                          {/* <Stack direction="row" spacing={2}>
                            {product?.isActive && (
                              <Chip label="Active" color="success" />
                            )}
                            {product?.isOnSale && (
                              <Chip label="On Sale" color="warning" />
                            )}
                            {product?.isPosDisplay && (
                              <Chip label="POS Display" color="info" />
                            )}
                          </Stack> */}

                          {/* Button Color Preview */}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      {productHistoryRecordList && productHistoryRecordList.length > 0 && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card
            className={classes.profileViewPageBackColor}
            sx={{
              padding: 2,
              height: "100%",
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.stepperCard}>
                  <Grid container justifyContent={"space-between"} spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={1}
                        sx={{ padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            alignContent: "center",
                          }}
                        >
                          <Typography
                            variant="h4"
                            fontWeight="bold"
                            color="primary"
                            gutterBottom
                            // textTransform={"uppercase"}
                          >
                            Price History
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ px: 2, pb: 3 }}
                        className={classes.titleGrid}
                      >
                        {productHistoryRecordList &&
                          productHistoryRecordList.length > 0 && (
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              width={"100%"}
                            >
                              {!storeRecordIsLoading && (
                                <ProductPriceChart
                                  data={productHistoryRecordList}
                                />
                              )}
                            </Grid>
                          )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      )}

      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={1}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color="primary"
                          gutterBottom
                          // textTransform={"uppercase"}
                        >
                          Update Variant History
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box
                      sx={{
                        height: "80vh",
                        overflow: "auto",
                        padding: "2px",
                        "&::-webkit-scrollbar": {
                          width: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#eeeeee",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#eeeeee",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#eeeeee",
                        },
                      }}
                    >
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ px: 2, pb: 3 }}
                        className={classes.titleGrid}
                      >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {coursings.map((row: IVariantView, index) => {
                            const prevRow =
                              index > 0 ? coursings[index - 1] : null;

                            const areEqual = (a: any, b: any) => {
                              if (Array.isArray(a) && Array.isArray(b)) {
                                return (
                                  a.length === b.length &&
                                  a.every((val, i) => val === b[i])
                                );
                              }
                              return a === b;
                            };

                            const getChangedProperties = (
                              current: any,
                              previous: any
                            ) => {
                              if (!previous) return {};
                              const changedProps: Record<
                                string,
                                { oldValue: any; newValue: any }
                              > = {};

                              Object.keys(current).forEach((key) => {
                                if (key === "id") return;
                                if (!areEqual(current[key], previous[key])) {
                                  changedProps[key] = {
                                    oldValue: previous[key],
                                    newValue: current[key],
                                  };
                                }
                              });

                              return changedProps;
                            };

                            const changedProperties = getChangedProperties(
                              row,
                              prevRow
                            );

                            // ✅ Filter out changes with both old and new value as null/empty
                            const meaningfulChanges = Object.entries(
                              changedProperties
                            ).filter(([key, { oldValue, newValue }]) => {
                              if (key === "variant_created_at") return false;
                              if (key === "updated_by") return false;
                              if (key === "created_by") return false;

                              const isEmpty = (val: any) =>
                                val === null ||
                                val === undefined ||
                                val === "" ||
                                val === "null" ||
                                (Array.isArray(val) && val.length === 0);

                              return !(isEmpty(oldValue) && isEmpty(newValue));
                            });

                            const hasChanges = meaningfulChanges.length > 0;

                            if (!prevRow || !hasChanges) return null;

                            return (
                              <Grid item xs={12} key={row.id} mt={4}>
                                <Card
                                  className={classes.stepperCardProductView}
                                >
                                  <CardContent>
                                    <Typography
                                      variant="subtitle2"
                                      color="primary"
                                      gutterBottom
                                    >
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                      >
                                        <span>— Updated —</span>
                                        {(prevRow.variant_created_at ||
                                          prevRow.updated_by) && (
                                          <span>
                                            {dayjs(
                                              prevRow.variant_created_at
                                            ).format("YYYY-MM-D hh:mm A")}
                                            {" / "}
                                            {userMap.get(prevRow.updated_by)}
                                          </span>
                                        )}
                                      </Box>
                                    </Typography>

                                    <Divider sx={{ mb: 2 }} />

                                    {meaningfulChanges.map(
                                      ([key, { oldValue, newValue }]) => {
                                        let displayOld = String(oldValue);
                                        let displayNew = String(newValue);

                                        if (key === "variantBrandId") {
                                          displayOld =
                                            productBrandMap.get(oldValue) || "";
                                          displayNew =
                                            productBrandMap.get(newValue) || "";
                                        } else if (key === "variantTagId") {
                                          displayOld = Array.isArray(oldValue)
                                            ? oldValue
                                                .map(
                                                  (id: any) =>
                                                    tagMap.get(id) || ""
                                                )
                                                .join(", ")
                                            : tagMap.get(oldValue) || "";
                                          displayNew = Array.isArray(newValue)
                                            ? newValue
                                                .map(
                                                  (id: any) =>
                                                    tagMap.get(id) || ""
                                                )
                                                .join(", ")
                                            : tagMap.get(newValue) || "";
                                        } else if (
                                          key === "variantPrinterIds"
                                        ) {
                                          displayOld = Array.isArray(oldValue)
                                            ? oldValue
                                                .map(
                                                  (id: any) =>
                                                    printerMap.get(id) || ""
                                                )
                                                .join(", ")
                                            : "";
                                          displayNew = Array.isArray(newValue)
                                            ? newValue
                                                .map(
                                                  (id: any) =>
                                                    printerMap.get(id) || ""
                                                )
                                                .join(", ")
                                            : "";
                                        } else if (
                                          [
                                            "isActive",
                                            "isOnSale",
                                            "isPosDisplay",
                                          ].includes(key)
                                        ) {
                                          const formatBool = (val: any) =>
                                            String(val) === "1" || val === true
                                              ? "Yes"
                                              : "No";

                                          displayOld = formatBool(oldValue);
                                          displayNew = formatBool(newValue);
                                        } else if (key === "variantUnit") {
                                          displayOld =
                                            convertUnit(oldValue) || "";
                                          displayNew =
                                            convertUnit(newValue) || "";
                                        }

                                        return (
                                          <Stack spacing={2} mt={1}>
                                            {key === "bgColor" ? (
                                              <Box
                                                key={key}
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                  mt: 1,
                                                }}
                                              >
                                                <Typography variant="subtitle1">
                                                  <strong>
                                                    {variantPropName(key)}:
                                                  </strong>
                                                </Typography>
                                                {newValue &&
                                                  newValue !== "null" && (
                                                    <Chip
                                                      label="Old Button Color"
                                                      sx={{
                                                        backgroundColor:
                                                          newValue,
                                                        color: "#fff",
                                                      }}
                                                    />
                                                  )}
                                                <IoIosArrowRoundForward
                                                  style={{
                                                    fontSize: 22,
                                                    color: "#1976d2",
                                                  }}
                                                />
                                                {oldValue &&
                                                  oldValue !== "null" && (
                                                    <Chip
                                                      label="New Button Color"
                                                      sx={{
                                                        backgroundColor:
                                                          oldValue,
                                                        color: "#fff",
                                                      }}
                                                    />
                                                  )}
                                              </Box>
                                            ) : key === "variantImg" ? (
                                              <Box
                                                key={key}
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 2,
                                                  mt: 1,
                                                }}
                                              >
                                                <Typography variant="subtitle1">
                                                  <strong>
                                                    {variantPropName(key)}:
                                                  </strong>
                                                </Typography>
                                                {newValue &&
                                                  newValue !== "null" && (
                                                    <img
                                                      src={newValue}
                                                      alt="New"
                                                      style={{
                                                        width: 50,
                                                        height: 50,
                                                        objectFit: "cover",
                                                        borderRadius: 4,
                                                      }}
                                                    />
                                                  )}
                                                <IoIosArrowRoundForward
                                                  style={{
                                                    fontSize: 22,
                                                    color: "#1976d2",
                                                  }}
                                                />
                                                {oldValue &&
                                                  oldValue !== "null" && (
                                                    <img
                                                      src={oldValue}
                                                      alt="Old"
                                                      style={{
                                                        width: 50,
                                                        height: 50,
                                                        objectFit: "cover",
                                                        borderRadius: 4,
                                                      }}
                                                    />
                                                  )}
                                              </Box>
                                            ) : (
                                              <Typography
                                                key={key}
                                                variant="subtitle1"
                                                sx={{
                                                  mt: 1,
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                <strong>
                                                  {variantPropName(key)}
                                                </strong>
                                                :&nbsp;
                                                {displayNew &&
                                                  displayNew !== "null" && (
                                                    <span>{displayNew}</span>
                                                  )}
                                                <IoIosArrowRoundForward
                                                  style={{
                                                    fontSize: 22,
                                                    color: "#1976d2",
                                                  }}
                                                />
                                                {displayOld &&
                                                  displayOld !== "null" && (
                                                    <span>{displayOld}</span>
                                                  )}
                                              </Typography>
                                            )}
                                          </Stack>
                                        );
                                      }
                                    )}
                                  </CardContent>
                                </Card>
                              </Grid>
                            );
                          })}

                          {coursings.length > 0 && (
                            <Grid item xs={12} mt={4}>
                              <Card className={classes.stepperCardProductView}>
                                <CardContent>
                                  <Typography
                                    variant="subtitle2"
                                    color="primary"
                                    gutterBottom
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <span>— Created —</span>
                                      {(coursings[coursings.length - 1]
                                        .variant_created_at ||
                                        coursings[coursings.length - 1]
                                          .updated_by) && (
                                        <span>
                                          {dayjs(
                                            coursings[coursings.length - 1]
                                              .variant_created_at
                                          ).format("YYYY-MM-D hh:mm A")}
                                          {" / "}
                                          {userMap.get(
                                            coursings[coursings.length - 1]
                                              .created_by
                                          )}
                                        </span>
                                      )}
                                    </Box>
                                  </Typography>

                                  <Divider sx={{ mt: 1, mb: 2 }} />

                                  <Stack spacing={1} mt={1}>
                                    {Object.entries(
                                      coursings[coursings.length - 1]
                                    ).map(([key, value]) => {
                                      if (
                                        [
                                          "id",
                                          "variant_created_at",
                                          "updated_by",
                                          "created_by",
                                          "isLooping",
                                        ].includes(key)
                                      )
                                        return null;

                                      let displayValue = String(value);

                                      if (key === "variantBrandId") {
                                        displayValue =
                                          productBrandMap.get(value) || "";
                                      } else if (key === "variantTagId") {
                                        displayValue = Array.isArray(value)
                                          ? value
                                              .map(
                                                (id: any) =>
                                                  tagMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : tagMap.get(value) || "";
                                      } else if (key === "variantPrinterIds") {
                                        displayValue = Array.isArray(value)
                                          ? value
                                              .map(
                                                (id: any) =>
                                                  printerMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : "";
                                      } else if (
                                        [
                                          "isActive",
                                          "isOnSale",
                                          "isPosDisplay",
                                        ].includes(key)
                                      ) {
                                        displayValue =
                                          String(value) === "1" ||
                                          value === true
                                            ? "Yes"
                                            : "No";
                                      } else if (key === "mainItemId") {
                                        displayValue =
                                          mainItenMap.get(value) || "";
                                      } else if (key === "variantUnit") {
                                        displayValue = convertUnit(value) || "";
                                      }

                                      const isEmpty =
                                        displayValue === "" ||
                                        displayValue === "null" ||
                                        displayValue === null;

                                      return !isEmpty ? (
                                        // <Typography
                                        //   key={key}
                                        //   variant="subtitle1"
                                        //   sx={{
                                        //     mt: 1,
                                        //     display: "flex",
                                        //     alignItems: "center",
                                        //     gap: 1,
                                        //   }}
                                        // >
                                        //   <strong>
                                        //     {variantPropName(key)}
                                        //   </strong>
                                        //   :&nbsp;
                                        //   {displayValue}
                                        // </Typography>

                                        <Stack spacing={2} mt={1}>
                                          {key === "bgColor" ? (
                                            <Box
                                              key={key}
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mt: 1,
                                              }}
                                            >
                                              <Typography variant="subtitle1">
                                                <strong>
                                                  {variantPropName(key)}:
                                                </strong>
                                              </Typography>

                                              {displayValue &&
                                                displayValue !== "null" && (
                                                  <Chip
                                                    label="New Button Color"
                                                    sx={{
                                                      backgroundColor:
                                                        displayValue,
                                                      color: "#fff",
                                                    }}
                                                  />
                                                )}
                                            </Box>
                                          ) : key === "variantImg" ? (
                                            <Box
                                              key={key}
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                mt: 1,
                                              }}
                                            >
                                              <Typography variant="subtitle1">
                                                <strong>
                                                  {variantPropName(key)}:
                                                </strong>
                                              </Typography>

                                              {displayValue &&
                                                displayValue !== "null" && (
                                                  <img
                                                    src={displayValue}
                                                    alt="Old"
                                                    style={{
                                                      width: 50,
                                                      height: 50,
                                                      objectFit: "cover",
                                                      borderRadius: 4,
                                                    }}
                                                  />
                                                )}
                                            </Box>
                                          ) : (
                                            <Typography
                                              key={key}
                                              variant="subtitle1"
                                              sx={{
                                                mt: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <strong>
                                                {variantPropName(key)}
                                              </strong>
                                              :&nbsp;
                                              {displayValue &&
                                                displayValue !== "null" && (
                                                  <span>{displayValue}</span>
                                                )}
                                            </Typography>
                                          )}
                                        </Stack>
                                      ) : null;
                                    })}
                                  </Stack>
                                </CardContent>
                              </Card>
                            </Grid>
                          )}
                        </Grid>

                        {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                        {coursings.map((row: IVariantView, index) => {
                          const prevRow =
                            index > 0 ? coursings[index - 1] : null;

                          const areEqual = (a: any, b: any) => {
                            if (Array.isArray(a) && Array.isArray(b)) {
                              return (
                                a.length === b.length &&
                                a.every((val, i) => val === b[i])
                              );
                            }
                            return a === b;
                          };

                          const getChangedProperties = (
                            current: any,
                            previous: any
                          ) => {
                            if (!previous) return {};
                            const changedProps: Record<
                              string,
                              { oldValue: any; newValue: any }
                            > = {};

                            Object.keys(current).forEach((key) => {
                              if (key === "id") return;
                              if (!areEqual(current[key], previous[key])) {
                                changedProps[key] = {
                                  oldValue: previous[key],
                                  newValue: current[key],
                                };
                              }
                            });

                            return changedProps;
                          };

                          const changedProperties = getChangedProperties(
                            row,
                            prevRow
                          );
                          const hasChanges =
                            Object.keys(changedProperties).length > 0;

                          if (!prevRow || !hasChanges) return null;

                          return (
                            <Grid item xs={12} key={row.id}>
                              <Card className={classes.stepperCard}>
                                <CardContent>
                                  <Typography
                                    variant="subtitle2"
                                    color="primary"
                                    gutterBottom
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <span>— Updated —</span>
                                      {prevRow.variant_created_at && (
                                        <span>
                                          {dayjs(prevRow.variant_created_at).format(
                                            "YYYY-MM-D hh:mm A"
                                          ) || ""}
                                        </span>
                                      )}
                                    </Box>
                                  </Typography>

                                  <Divider sx={{ mb: 2 }} />

                                  {Object.entries(changedProperties).map(
                                    ([key, { oldValue, newValue }]) => {
                                      if (key === "variant_created_at") return null;
                                      let displayOld = String(oldValue);
                                      let displayNew = String(newValue);

                                      if (key === "variantBrandId") {
                                        displayOld =
                                          productBrandMap.get(oldValue) || "";
                                        displayNew =
                                          productBrandMap.get(newValue) || "";
                                      } else if (key === "variantTagId") {
                                        displayOld = Array.isArray(oldValue)
                                          ? oldValue
                                              .map(
                                                (id: any) =>
                                                  tagMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : tagMap.get(oldValue) || "";
                                        displayNew = Array.isArray(newValue)
                                          ? newValue
                                              .map(
                                                (id: any) =>
                                                  tagMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : tagMap.get(newValue) || "";
                                      } else if (key === "variantPrinterIds") {
                                        displayOld = Array.isArray(oldValue)
                                          ? oldValue
                                              .map(
                                                (id: any) =>
                                                  printerMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : "";
                                        displayNew = Array.isArray(newValue)
                                          ? newValue
                                              .map(
                                                (id: any) =>
                                                  printerMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : "";
                                      }

                                      return (
                                        <Typography
                                          key={key}
                                          sx={{
                                            mt: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                          }}
                                        >
                                          <strong>
                                            {variantPropName(key)}
                                          </strong>
                                          :&nbsp;
                                          <span>
                                            {displayNew && displayNew !== "null"
                                              ? displayNew
                                              : ""}
                                          </span>
                                          <IoIosArrowRoundForward
                                            color="primary"
                                            style={{
                                              fontSize: 22,
                                            }}
                                          />
                                          <span>
                                            {displayOld && displayOld !== "null"
                                              ? displayOld
                                              : ""}
                                          </span>
                                        </Typography>
                                      );
                                    }
                                  )}
                                </CardContent>
                              </Card>
                            </Grid>
                          );
                        })}
                      </Grid> */}
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialogProduct}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}

      {selectedProduct2 && (
        <StorepriceOnly
          openModel={openDialogProduct2}
          handleCloseDialog={handleCloseDialog2}
          data={selectedProduct2}
        />
      )}
      {productToDelete && (
        <DeletePopup
          open={openDeleteProduct}
          handleCloseDelete={handleCloseDeletePopup}
          onConfirm={async () => {
            await handleDelete(productToDelete.id.toString());
          }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDelete.variantName}"?`}
        />
      )}
    </Grid>
  );
};

export default Index;
